import { Box, Chip, List, ListItemButton, ListItemText, Typography } from "@mui/material";

/** Search hits, each showing the full breadcrumb path the backend resolved for it. */
const SearchResults = ({ result, onOpenFolder, onOpenFile }) => {
  const folders = result?.folders || [];
  const files = result?.files || [];

  if (folders.length === 0 && files.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        Nothing matched.
      </Typography>
    );
  }

  return (
    <Box>
      {folders.length > 0 && (
        <>
          <Typography variant="overline" color="text.secondary">
            Folders
          </Typography>
          <List dense>
            {folders.map((folder) => (
              <ListItemButton key={`folder-${folder.id}`} onClick={() => onOpenFolder(folder.id)}>
                <ListItemText primary={folder.name} secondary={folder.path} />
                <Chip size="small" label="Folder" />
              </ListItemButton>
            ))}
          </List>
        </>
      )}
      {files.length > 0 && (
        <>
          <Typography variant="overline" color="text.secondary">
            Documents
          </Typography>
          <List dense>
            {files.map((file) => (
              <ListItemButton key={`file-${file.id}`} onClick={() => onOpenFile(file)}>
                <ListItemText primary={file.name} secondary={file.path} />
              </ListItemButton>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default SearchResults;
